export enum SequenceState {
  INACTIVE = 'Inactive',
  PAUSED = 'paused',
  RUNNING = 'running',
  WAITING = 'waiting',
}
